module.exports = __webpack_public_path__ + "fonts/Inter-900-latin-ext83.ad4eb06.woff2";